/**
 * Em Breve — Coming Soon
 *
 * 1. Detecta retorno do formulário nativo Shopify (/contact?contact[result]=success)
 *    e exibe a mensagem de sucesso sem redirecionar o cliente.
 * 2. Mantém o campo contact[body] atualizado com o variant_id correto
 *    quando o cliente troca de variante na página de produto.
 * 3. Reordena cards "em-breve" para o final em grids e carrosséis.
 *
 * Não há nenhuma chamada a endpoints externos aqui.
 * O formulário posta diretamente para /contact (Shopify nativo, com CSRF).
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1. MENSAGEM DE SUCESSO APÓS REDIRECT DO SHOPIFY
     Após o POST para /contact, o Shopify redireciona para a mesma URL
     com o parâmetro: ?contact%5Bresult%5D=success
     Detectamos isso e exibimos o feedback sem nova requisição.
     ------------------------------------------------------------------ */
  function handleContactFormResult() {
    var params = new URLSearchParams(window.location.search);
    // Shopify pode codificar como "contact[result]" ou "contact%5Bresult%5D"
    var result = params.get('contact[result]') || params.get('contact%5Bresult%5D');
    if (!result) return;

    var formRow  = document.getElementById('emBreveFormRow');
    var msgOk    = document.getElementById('emBreveSuccess');
    var msgErr   = document.getElementById('emBreveError');

    if (result === 'success') {
      if (formRow) formRow.hidden = true;
      if (msgOk)   msgOk.hidden  = false;
    } else {
      if (msgErr)  msgErr.hidden  = false;
    }

    // Limpa o parâmetro da URL sem recarregar a página
    var cleanUrl = window.location.pathname + window.location.hash;
    history.replaceState(null, '', cleanUrl);
  }

  /* ------------------------------------------------------------------
     2. SINCRONIZAR VARIANT ID NO CAMPO OCULTO contact[body]
     Quando o cliente troca de variante, atualizamos o JSON no campo
     contact[body] para que o Shopify/N8N receba o ID correto.
     ------------------------------------------------------------------ */
  function syncNotifyFormVariant() {
    var bodyField = document.getElementById('emBreveNotifyBody');
    if (!bodyField) return;

    function updateBody(variantId) {
      try {
        var data = JSON.parse(bodyField.value);
        data.variant_id = String(variantId);
        bodyField.value = JSON.stringify(data);
        bodyField.dataset.variant = variantId;
      } catch (e) { /* silencioso */ }
    }

    // Escuta o evento customizado emitido por product-info.js do Dawn
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        updateBody(e.detail.variant.id);
      }
    });

    // Fallback: observa mudança de value no input hidden de variante
    var variantInput = document.querySelector('.product-variant-id');
    if (variantInput) {
      var observer = new MutationObserver(function () {
        if (variantInput.value) updateBody(variantInput.value);
      });
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  /* ------------------------------------------------------------------
     3. REORDENAÇÃO DE CARDS EM CARROSSÉIS E GRIDS
     Move elementos [data-em-breve="true"] para o final do container pai.
     Funciona para CSS Grid, Flexbox e carrosséis Swiper.
     ------------------------------------------------------------------ */
  function reorderEmBreveCards() {
    var emBreveCards = document.querySelectorAll('[data-em-breve="true"]');

    emBreveCards.forEach(function (card) {
      var slide = card.closest('li') || card.closest('.swiper-slide') || card.parentElement;
      if (!slide) return;

      var container = slide.parentElement;
      if (!container) return;

      container.appendChild(slide);
    });

    // Atualiza instâncias Swiper se existirem
    if (typeof Swiper !== 'undefined') {
      document.querySelectorAll('.swiper').forEach(function (el) {
        if (el.swiper) el.swiper.update();
      });
    }
  }

  /* ------------------------------------------------------------------
     INIT
     ------------------------------------------------------------------ */
  function init() {
    handleContactFormResult();
    syncNotifyFormVariant();
    reorderEmBreveCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
